import {
  Event,
  Location,
  Model
} from "../interfaces";

export const mockModelsSelected: Model[] = [
  /*  {
    id: 1,
    bio: {
      name: "Elena",
      surname: "Lily",
      nationality: "Sweden",
      birth_date: new Date("12 / 12 / 2000"),
      place: "France",
    },
    measures: {
      waist: 40,
      bust: 43,
      hair: "Blonde",
      eyes: "Blue",
      height: 183,
      hips: 45,
      shoes: 39,
    },
    contacts: {
      socials: {
        instagram: { link: "http://instagram.com", followers: 999 },
        facebook: { link: "http://facebook.com", followers: 999 },
        tiktok: { link: "http://tiktok.com", followers: 999 },
      },
      mail: "elena@gmail.com",
      agency: "TUA",
      phone: "23453452654",
    },
    portfolio: {
      documents: [{ obj: 1 }, { obj: 2 }],
      photos: [{ obj: 1 }, { obj: 2 }],
      polaroids: [{ obj: 1 }, { obj: 2 }],
      videos: [{ obj: 1 }],
    },
    proposal: { approved_times: 55, proposed_times: 125 },

    work_categories: {
      catalog: 24,
      look_book: 54,
      campaign: 16,
      editorial: 74,
      show: 58,
      showroom: 31,
      digital: 19,
      tv_commercial: 86,
    },
    profileImageSrc: " ",
  },
  {
    id: 2,
    bio: {
      name: "Jhona",
      surname: "Onario",
      nationality: "Mexico",
      birth_date: new Date("5 / 15 / 2001"),
      place: "Spain",
    },
    measures: {
      waist: 42,
      bust: 53,
      hair: "Black",
      eyes: "Brown",
      height: 173,
      hips: 48,
      shoes: 35,
    },
    contacts: {
      socials: {
        instagram: { link: "http://instagram.com", followers: 999 },
        facebook: { link: "http://facebook.com", followers: 999 },
        tiktok: { link: "http://tiktok.com", followers: 999 },
      },
      mail: "jhona@gmail.com",
      agency: "Other",
      phone: "897643565",
    },
    portfolio: {
      documents: [{ obj: 1 }, { obj: 2 }],
      photos: [{ obj: 1 }, { obj: 2 }],
      polaroids: [{ obj: 1 }, { obj: 2 }],
      videos: [{ obj: 1 }],
    },
    proposal: {
      approved_times: 25,
      proposed_times: 110,
    },
    work_categories: {
      catalog: 64,
      look_book: 14,
      campaign: 19,
      editorial: 64,
      show: 88,
      showroom: 21,
      digital: 69,
      tv_commercial: 55,
    },
    profileImageSrc: " ",
  },
  {
    id: 3,
    bio: {
      name: "Giorgia",
      surname: "Crio",
      nationality: "Italian",
      birth_date: new Date("11 / 7 / 2003"),
      place: "Tokyo",
    },
    measures: {
      hair: "Red",
      shoes: 34,
      bust: 48,
      eyes: "Grey",
      height: 178,
      hips: 41,
      waist: 42,
    },
    contacts: {
      socials: {
        instagram: { link: "http://instagram.com", followers: 999 },
        facebook: { link: "http://facebook.com", followers: 999 },
        tiktok: { link: "http://tiktok.com", followers: 999 },
      },
      mail: "giorgia@gmail.com",
      agency: "TUA",
      phone: "633123754",
    },
    portfolio: {
      documents: [{ obj: 1 }, { obj: 2 }],
      photos: [{ obj: 1 }, { obj: 2 }],
      polaroids: [{ obj: 1 }, { obj: 2 }],
      videos: [{ obj: 1 }],
    },
    proposal: {
      approved_times: 25,
      proposed_times: 98,
    },

    work_categories: {
      catalog: 24,
      look_book: 34,
      campaign: 69,
      editorial: 34,
      show: 48,
      showroom: 11,
      digital: 79,
      tv_commercial: 25,
    },
    profileImageSrc: " ",
  },
  {
    id: 4,
    bio: {
      name: "Nina",
      surname: "Ni",
      nationality: "Russian",
      birth_date: new Date("8 / 8 / 1998"),
      place: "USA",
    },
    measures: {
      hair: "Brown",
      shoes: 38,
      bust: 45,
      eyes: "Green",
      height: 188,
      hips: 41,
      waist: 42,
    },
    contacts: {
      socials: {
        instagram: { link: "http://instagram.com", followers: 999 },
        facebook: { link: "http://facebook.com", followers: 999 },
        tiktok: { link: "http://tiktok.com", followers: 999 },
      },
      mail: "nina@gmail.com",
      agency: "Kunai",
      phone: "548763376",
    },
    portfolio: {
      documents: [{ obj: 1 }, { obj: 2 }],
      photos: [{ obj: 1 }, { obj: 2 }],
      polaroids: [{ obj: 1 }, { obj: 2 }],
      videos: [{ obj: 1 }],
    },
    proposal: {
      approved_times: 25,
      proposed_times: 88,
    },
    work_categories: {
      catalog: 24,
      look_book: 34,
      campaign: 69,
      editorial: 34,
      show: 48,
      showroom: 11,
      digital: 79,
      tv_commercial: 25,
    },
    profileImageSrc: " ",
  }, */
];

/* export const mockClients: Client[] = [
  {
    id: 1,
    address: "5121 Tilden Avenue Brooklyn New York",
    location: "United States",
    mail: "novak@info.com",
    mobile: "+393685945",
    name: "Mela",
    phone: "+393685945",
    referent_name: "Novak Martinez",
    website: "www.thesaintnyc.com",
    amount_spent: 8675.43,
    earning: 2.452,
  },
  {
    id: 2,
    address: "821 Main Street Los Angeles",
    location: "United States",
    mail: "jake@info.com",
    mobile: "+3998076234",
    name: "Hertz",
    phone: "+3998076234",
    referent_name: "Jake Landcot",
    website: "www.sunshine.com",
    amount_spent: 3425.78,
    earning: 1.222,
  },
  {
    id: 3,
    address: "125 Kinamoe Shinjuku Tokyo",
    location: "Japan",
    mail: "tojiro@info.com",
    mobile: "+3945736223",
    name: "Juniper",
    phone: "+3945736223",
    referent_name: "Tojiro Kobayashi",
    website: "www.thehall.com",
    amount_spent: 5321.23,
    earning: 3.761,
  },
  {
    id: 4,
    address: "255 Piazza Roma",
    location: "Italy",
    mail: "fernanda@info.com",
    mobile: "+395678323",
    name: "Accordia",
    phone: "+395678323",
    referent_name: "Fernanda Rossi",
    website: "www.accordia.com",
    amount_spent: 1321.23,
    earning: 1.761,
  },
];

export const mockUsersSelected: User[] = [
  {
    id: 5,
    email: "joy@tua.com",
    name: "Joy",
    status: "pending",
    surname: "Gunna",
    role: "normal",
    password: "pwtest1",
  },

  {
    id: 56,
    email: "enrico@tua.com",
    name: "Enrico",
    status: "active",
    surname: "Stucchi",
    role: "normal",
    password: "pwtest2",
  },

  {
    id: 78,
    email: "Erika@tua.com",
    name: "Erika",
    status: "active",
    surname: "Brimstone",
    role: "normal",
    password: "pwtest3",
  },
  {
    id: 11,
    email: "boris@tua.com",
    name: "Boris",
    status: "active",
    surname: "Denovak",
    role: "normal",
    password: "pwtest4",
  },

  {
    id: 2,
    email: "gina@tua.com",
    name: "Gina",
    status: "active",
    surname: "Annioli",
    role: "normal",
    password: "pwtest5",
  },

  {
    id: 135,
    email: "minako@tua.com",
    name: "Minako",
    status: "pending",
    surname: "Asakure",
    role: "normal",
    password: "pwtest6",
  },
]; */
/* 
export const mockOffers: Offer[] = [
  {
    budget: 4352,
    budget_shared: true,
    category: "Show",
    composite_shared: false,
    short_description: "Nothing to say in particular",
    expiration_date: true,
    id: 23,
    imageSrc: "/mockOffersImages/offer1.png",
    issue_date: new Date("2022/10/05"),
    link: "http://google.com",
    location: "New York",
    lookbook_shared: false,
    offer_name: "Sunset Field",
    password: false,
    requested_models: 3,
    client: "Mela",
    long_description:
      "This is a long deescription test and ther's nothing to say....please go on.",
    status: "open",
  },
  {
    budget: 7352,
    budget_shared: false,
    category: "Campaign",
    composite_shared: true,
    short_description: "Third series",
    expiration_date: true,
    id: 17,
    imageSrc: "/mockOffersImages/offer2.jpg",
    issue_date: new Date("2022/09/01"),
    link: "http://google.com",
    location: "Oslo",
    lookbook_shared: false,
    offer_name: "The Woodland",
    password: true,
    requested_models: 5,
    client: "Hertz",
    long_description:
      "Welcome to third series of this new project called The Woodland! We hope you have whaty we need so let's start this!",
    status: "approved",
    approved_date: new Date("2022/10/10"),
  },
  {
    budget: 1352,
    budget_shared: false,
    category: "Editorial",
    composite_shared: true,
    short_description: "Season 5",
    expiration_date: false,
    id: 47,
    imageSrc: "/mockOffersImages/offer4.jpg",
    issue_date: new Date("2022/11/06"),
    link: "http://google.com",
    location: "Tokyo",
    lookbook_shared: false,
    offer_name: "Skyline",
    password: false,
    requested_models: 6,
    client: "Juniper",
    long_description:
      "Another long description to test the content of this offer....BYE!!!!",
    status: "open",
  },
  {
    budget: 2352,
    budget_shared: false,
    category: "Campaign",
    composite_shared: true,
    short_description: "Circle number 5",
    expiration_date: false,
    id: 47,
    imageSrc: "/mockOffersImages/offer2.jpg",
    issue_date: new Date("2022/11/07"),
    link: "http://google.com",
    location: "Kyoto",
    lookbook_shared: false,
    offer_name: "Sunsrise Bridge",
    password: false,
    requested_models: 2,
    client: "Mela",
    long_description:
      "Another long description to test the content of this offer....BYE!!!!",
    status: "open",
  },
  {
    budget: 2452,
    budget_shared: false,
    category: "Catalog",
    composite_shared: true,
    short_description: "New thing",
    expiration_date: false,
    id: 167,
    imageSrc: "/mockOffersImages/offer2.jpg",
    issue_date: new Date("2022/10/03"),
    link: "http://google.com",
    location: "Paris",
    lookbook_shared: false,
    offer_name: "Switch View SRL",
    password: false,
    requested_models: 2,
    client: "Mela",
    long_description: "Another description .....",
    status: "open",
  },
  {
    budget: 656.45,
    budget_shared: false,
    category: "Show",
    composite_shared: true,
    short_description: "Random",
    expiration_date: false,
    imageSrc: "/mockOffersImages/offer2.jpg",
    issue_date: new Date("2022/9/03"),
    link: "http://google.com",
    location: "Berlin",
    lookbook_shared: false,
    offer_name: "Color Blind Center SPA",
    password: false,
    requested_models: 2,
    client: "Hertz",
    long_description: "Test long description for testing lot of stuffs.....",
    status: "closed",
    approved_date: new Date("2022/09/11"),
    close_date: new Date("2022/09/22"),
    models_proposed_list: [1, 2, 3, 4],
    models_accepted_list: [2, 1],
  },
  {
    budget: 356.27,
    budget_shared: false,
    category: "Catalog",
    composite_shared: true,
    short_description: "Random description",
    expiration_date: false,
    imageSrc: "/mockOffersImages/offer3.jpg",
    issue_date: new Date("2022/11/13"),
    link: "http://google.com",
    location: "Rome",
    lookbook_shared: false,
    offer_name: "Border Side Effect",
    password: false,
    requested_models: 3,
    client: "Mela",
    long_description: "Test long description for testing lot of stuffs.....",
    status: "closed",
    approved_date: new Date("2022/11/20"),
    close_date: new Date("2022/11/22"),
    models_proposed_list: [1, 2, 3, 4],
    models_accepted_list: [3, 2, 4],
  },
  {
    budget: 842.45,
    budget_shared: false,
    category: "Editorial",
    composite_shared: true,
    short_description: "Short description here",
    expiration_date: false,
    imageSrc: "/mockOffersImages/offer3.jpg",
    issue_date: new Date("2022/9/22"),
    link: "http://google.com",
    location: "London",
    lookbook_shared: false,
    offer_name: "Library Mall",
    password: false,
    requested_models: 1,
    client: "Juniper",
    long_description: "Test long description for testing lot of stuffs.....",
    status: "closed",
    approved_date: new Date("2022/10/23"),
    close_date: new Date("2022/11/03"),
    models_proposed_list: [1, 2, 3, 4],
    models_accepted_list: [4],
  },
  {
    budget: 342.45,
    budget_shared: false,
    category: "Editorial",
    composite_shared: true,
    short_description: "Short description here",
    expiration_date: false,
    imageSrc: "/mockOffersImages/offer1.jpg",
    issue_date: new Date("2022/9/12"),
    link: "http://google.com",
    location: "Paris",
    lookbook_shared: false,
    offer_name: "Boutique Genò",
    password: false,
    requested_models: 2,
    client: "Hertz",
    long_description: "Test long description for testing lot of stuffs.....",
    status: "closed",
    approved_date: new Date("2022/10/23"),
    close_date: new Date("2022/11/03"),
    models_proposed_list: [1, 2, 3, 4],
    models_accepted_list: [1, 3],
  },
]; */

/* export const mockNews: News[] = [
  {
    bg_imageSrc: "/mockNewsImages/models.jpg",
    description: "It all starts with the creations of the models.",
    cta: { text: "Go to Models", section_link: "/models" },
    title: "Start by entering the models",
  },
  {
    bg_imageSrc: "/mockNewsImages/clients.jpg",
    description: "Create and manage your clients. Keep under control the results of their offers",
    cta: { text: "Go to Clients", section_link: "/clients" },
    title: "Create the client",
  },
  {
    bg_imageSrc: "/mockNewsImages/offers.jpg",
    description: "Create an offer and update it's status",
    cta: { text: "Go to Offers", section_link: "/offers" },
    title: "keep in view the offers",
  },
]; */

export const mocEvents: Event[] = [
  {
    id: 11,
    related_client_id: 22,
    related_offer_id: 77,
    related_offer_name: "Shooting Il Borro Relais & Châteaux",
    related_offer_category: "Campaign",
    address: "London, UK",
    starting_date: new Date("January 23, 23 11:20"),
    ending_date: new Date("January 23, 23 14:40"),
  },
  {
    id: 23,
    related_client_id: 431,
    related_offer_id: 78,
    related_offer_name: "Spain lake",
    related_offer_category: "Lookbook",
    address: "Paris, France",
    starting_date: new Date("January 24, 23 17:10"),
    ending_date: new Date("January 24, 23 20:50"),
  },
  {
    id: 71,
    related_client_id: 11,
    related_offer_id: 80,
    related_offer_name: "Tavern revivals",
    related_offer_category: "Digital",
    address: "Berlin, Germany",
    starting_date: new Date("January 25, 23 04:20"),
    ending_date: new Date("January 26, 23 14:33"),
  },
  {
    id: 134,
    related_client_id: 32,
    related_offer_id: 82,
    related_offer_name: "Sunset SPA commercial",
    related_offer_category: "Editorial",
    address: "Rome, Italy",
    starting_date: new Date("January 27, 23 19:20"),
    ending_date: new Date("January 27, 23 21:45"),
  },
  {
    id: 1,
    related_client_id: 56,
    related_offer_id: 85,
    related_offer_name: "Evento test",
    related_offer_category: "Show",
    address: "Rome, Italy",
    starting_date: new Date("January 31, 23 21:20"),
    ending_date: new Date("February 1, 23 2:34"),
  },
  {
    id: 2,
    related_client_id: 5,
    related_offer_id: 87,
    related_offer_name: "Evento test2",
    related_offer_category: "Show",
    address: "Genova, Italy",
    starting_date: new Date("January 28, 23 11:20"),
    ending_date: new Date("January 28, 23 13:34"),
  },
];

/* export const mockModelLocation: Location[] = [
  {
    id: 1,
    related_model_id: 255,
    location: "Singapore",
    starting_date: new Date(),
    ending_date: new Date("January 31, 23"),
  },
  {
    id: 2,
    related_model_id: 255,
    location: "Paris",
    starting_date: new Date("February 2, 23"),
    ending_date: new Date("February 5, 23"),
  },
  {
    id: 3,
    related_model_id: 255,
    location: "Rome",
    starting_date: new Date("February 3, 23"),
    ending_date: new Date("February 3, 23"),
  },
]; */
